import { render, staticRenderFns } from "./PlayRoute.vue?vue&type=template&id=3459be84&scoped=true&"
import script from "./PlayRoute.vue?vue&type=script&lang=js&"
export * from "./PlayRoute.vue?vue&type=script&lang=js&"
import style0 from "./PlayRoute.vue?vue&type=style&index=0&id=3459be84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3459be84",
  null
  
)

export default component.exports